import { ReactComponent as Icon } from './startUpComarison.svg'
import { theme } from '@ss/meta-core-components'
import React, { CSSProperties } from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
  style?: CSSProperties
}

export const StartUpComparisonIcon: React.FC<Props> = ({
  ariaLabel = 'startUpComparison',
  role = 'icon',
  style,
}) => {
  //todo: theme
  return (
    <Icon
      style={style}
      aria-label={ariaLabel}
      role={role}
      data-cy={'start-up-comparison-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
